import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from "rxjs/Observable";

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/catch';

import * as globalConst from './../../../../constants';

@Injectable()
export class FixedLimitService {

	private apiUrl = globalConst.baseAPI;

	constructor(private http: Http) { }

	fixLimitList(obj) {
		return this.http
			.post(this.apiUrl + "proposalLC/v1/fixedLimitClientList/", obj, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	fixLimitPartialList(obj) {
		return this.http
			.post(this.apiUrl + "proposalLC/v1/fixedLimitClientPartialList/", obj, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

}



// WEBPACK FOOTER //
// ./src/app/limit-flow-proposal/service/limit-flow-proposal/fixed-limit.service.ts